import { Box, Stack, Typography, styled } from '@mui/material'
import { Button } from '@center/ui-kit'

export const CPCContainer = styled(Stack)(({ theme }) => `
  gap: 15px;
  justify-content: center;
  align-items: center;
  padding: ${theme.spacing(2, 0, 2)};
  min-width: 130px;
  box-shadow: 0px 16px 24px -8px #00000029;
  border-radius: ${theme.spacing(1)};
  background-color: #ffffff;
  color: ${theme.palette.grey['800']};
`)

export const CPCCountry = styled(Typography)`
  color: #79828b;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
`

export const CPCPercentageContainer = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 2px;
`

export const CPCPercentage = styled(Typography)`
  font-size: 20px;
  font-weight: 600;
`

export const CPCValue = styled(Typography)`
  font-size: 10px;
  align-self: flex-start;
  font-weight: 600;
  line-height: 24px;
`

export const Carousel = styled(Box)`
  height: 100%; 
  display: flex;
  background-color: #f2f3f8;
  border-radius: 8px;
  overflow: hidden;
`

export const UCPCardContainer = styled(Box)(({ theme }) => `
  display: flex;
  flex: 1;
  overflow: hidden;
  overflow-x: scroll;
  padding: ${theme.spacing(1)};
  gap: ${theme.spacing(2)};
  -ms-overflow-style: none;
  scrollbar-width: none;
  width: 0;

  &::-webkit-scrollbar {
    display: none;
  }
`)

export const UCPButtonContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding: 8px;
  background-color: hsla(230, 30%, 96%, 0.4);
`

export const UCPButton = styled(Button)`
  background-color: white;
  padding: 0 10px;
`
